// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","EPGButton":"_1lViKw","icon":"_26PbJw","fadeInFrames":"_26pm46"};